{
  "common": {
    "loading": "Caricamento...",
    "cancel": "Cancellare",
    "save": "Salva",
    "save_changes": "Salva modifiche",
    "delete": "Eliminare",
    "edit": "Modificare",
    "close": "Vicino",
    "submit": "Invia",
    "saving": "Risparmio...",
    "sending": "Invio in corso...",
    "error": "Errore",
    "success": "Successo",
    "warning": "Avvertimento",
    "note": "Nota",
    "no_data": "Nessun dato",
    "yes": "SÌ",
    "no": "NO",
    "back": "Indietro",
    "next": "Prossimo",
    "previous": "Precedente",
    "search": "Ricerca",
    "filter": "Filtro",
    "all": "Tutto",
    "none": "Nessuno",
    "select": "Selezionare",
    "required": "Necessario",
    "optional": "Opzionale",
    "actions": "Azioni",
    "status": "Stato",
    "date": "Data",
    "time": "Tempo",
    "name": "Nome",
    "email": "E-mail",
    "confirm": "Confermare",
    "add": "Aggiungi",
    "done": "Fatto",
    "unknown": "Sconosciuto",
    "days": "giorni",
    "to": "a"
  },
  "time": {
    "day": "giorno",
    "days": "giorni",
    "hour": "ora",
    "hours": "ore",
    "week": "settimana",
    "weeks": "settimane",
    "month": "mese",
    "months": "mesi",
    "year": "anno",
    "years": "anni",
    "today": "Oggi",
    "tomorrow": "Domani",
    "yesterday": "Ieri"
  },
  "status": {
    "pending": "In attesa di",
    "approved": "Approvato",
    "rejected": "Respinto",
    "cancelled": "Annullato",
    "active": "Attivo",
    "inactive": "Inattivo",
    "deleted": "Eliminato",
    "connected": "Collegato",
    "disconnected": "Disconnesso",
    "available": "Disponibile",
    "coming_soon": "Prossimamente"
  },
  "nav": {
    "dashboard": "Pannello di controllo",
    "planner": "Pianificatore",
    "team": "Squadra",
    "requests": "Richieste",
    "calendar": "Calendario",
    "settings": "Impostazioni",
    "audit_trail": "Pista di controllo",
    "billing": "Fatturazione",
    "help": "Aiuto",
    "help_center": "Centro assistenza",
    "profile": "Profilo",
    "my_balances": "I miei saldi",
    "leave_history": "Storico permessi",
    "restart_tour": "Riavvia il tour",
    "logout": "Disconnessione",
    "upgrade": "Passa a Pro",
    "upgrade_subtitle": "Sblocca tutte le funzionalità",
    "view_plans": "Visualizza i piani"
  },
  "header": {
    "profile_settings": "Impostazioni del profilo",
    "my_profile": "Il mio profilo",
    "workspace": "Area di lavoro",
    "leave_balances": "Saldi delle ferie",
    "no_balances": "Nessun saldo ferie trovato."
  },
  "balance": {
    "unlimited": "Illimitato",
    "days_left": "giorni rimasti",
    "used": "usato",
    "remaining": "rimanente",
    "of": "di"
  },
  "trial": {
    "ends_today": "La tua prova termina oggi!",
    "ends_tomorrow": "La tua prova termina domani!",
    "ends_in_days": "La prova termina tra {giorni} giorni.",
    "upgrade_now": "Aggiorna ora"
  },
  "feature_locked": {
    "title": "{feature} non è disponibile nel tuo piano",
    "description": "Aggiorna il tuo piano per sbloccare questa funzionalità e molto altro.",
    "button": "Visualizza i piani"
  },
  "dashboard": {
    "title": "Pannello di controllo",
    "out_today": "Fuori oggi",
    "out_on_date": "Uscita il {data}",
    "no_absences": "Nessuna assenza",
    "upcoming": "Prossime Assenze",
    "upcoming_empty": "Nessuna assenza imminente questa settimana",
    "my_balance": "Il mio saldo ferie",
    "my_balances": "I miei saldi",
    "no_balance_data": "Nessun dato di saldo",
    "next_holiday": "Prossimo giorno festivo",
    "no_holidays": "Nessuna festività imminente",
    "next_vacation": "La mia prossima vacanza",
    "nothing_booked": "Niente di prenotato!",
    "upcoming_birthdays": "Prossimi compleanni",
    "no_birthdays": "Nessun compleanno imminente",
    "birthday_today": "Oggi!",
    "birthday_in_days": "in {days} {unit}",
    "everyone_in_office": "Tutti sono in ufficio in questo giorno",
    "request_leave": "Richiedi congedo",
    "view_calendar": "Visualizza calendario",
    "view_planner": "Visualizza Planner",
    "contact_support": "Contatta l'assistenza"
  },
  "support": {
    "title": "Contatta l'assistenza",
    "success_title": "Messaggio inviato!",
    "success_message": "Ti risponderemo il prima possibile.",
    "intro": "Hai bisogno di aiuto? Inviaci un messaggio e ti risponderemo al più presto.",
    "subject_label": "Soggetto",
    "subject_placeholder": "Breve descrizione del problema",
    "message_label": "Messaggio",
    "message_placeholder": "Descrivi dettagliatamente il tuo problema o la tua domanda...",
    "send_button": "Invia messaggio"
  },
  "requests": {
    "page_title": "Richieste di congedo",
    "page_subtitle": "Esaminare e gestire le richieste di congedo",
    "new_request": "Richiedi congedo",
    "unpaid_confirm": "Solo {paid} {unit} di questa richiesta sono coperte dal tuo saldo retribuito. Le restanti {unpaid} {unit} saranno prese come ferie non retribuite. Inviare comunque?",
    "filter": {
      "pending": "In attesa di",
      "approved": "Approvato",
      "rejected": "Respinto",
      "all": "Tutto",
      "all_employees": "Tutti i dipendenti"
    },
    "table": {
      "employee": "Dipendente",
      "type": "Tipo",
      "dates": "Date",
      "duration": "Durata",
      "status": "Stato",
      "reason": "Motivo",
      "actions": "Azioni"
    },
    "action": {
      "approve": "Approvare",
      "reject": "Rifiutare",
      "cancel": "Cancellare"
    },
    "empty": {
      "title": "Nessuna richiesta trovata",
      "pending": "Nessuna richiesta in sospeso da esaminare.",
      "filtered": "Nessuna richiesta di congedo corrisponde al tuo filtro."
    },
    "modal": {
      "reject_title": "Rifiuta richiesta",
      "reason_label": "Motivo del rifiuto",
      "reason_placeholder": "Motivo della richiesta di congedo...",
      "reject_button": "Rifiutare",
      "request_title": "Richiedi congedo",
      "employee_label": "Dipendente",
      "leave_type_label": "Tipo di congedo",
      "start_date_label": "Data di inizio",
      "end_date_label": "Data di fine",
      "start_time_label": "Ora di inizio",
      "end_time_label": "Ora di fine",
      "reason_optional": "Motivo (facoltativo)",
      "submit_button": "Invia richiesta",
      "submitting": "Invio in corso...",
      "minimum_duration": "Minimo: {duration} {unit}"
    }
  },
  "calendar": {
    "page_title": "Calendario della squadra",
    "page_subtitle": "Visualizza le assenze del team e i permessi programmati",
    "filters": {
      "button": "Filtri"
    },
    "sync": {
      "title": "Sincronizza il tuo calendario",
      "description": "Collega il tuo calendario personale per sincronizzare automaticamente i permessi approvati"
    },
    "connect": {
      "google": "Calendario di Google",
      "microsoft": "Calendario Microsoft"
    },
    "action": {
      "disconnect": "Disconnettersi",
      "sync_my_leave": "Sincronizza il mio congedo",
      "sync_team_leave": "Congedo del team di sincronizzazione"
    },
    "connecting": "Connessione in corso...",
    "syncing": "Sincronizzazione in corso...",
    "autosync": {
      "title": "Sincronizzazione automatica delle ferie del team",
      "description": "Aggiungi automaticamente al tuo calendario i permessi approvati dai membri del team"
    },
    "filter": {
      "department_label": "Dipartimento",
      "all_departments": "Tutti i dipartimenti",
      "location_label": "Posizione",
      "all_locations": "Tutte le località",
      "leave_type_label": "Tipo di congedo",
      "all_types": "Tutti i tipi",
      "status_label": "Stato",
      "all_status": "Tutti gli stati"
    },
    "nav": {
      "today": "Oggi"
    },
    "view": {
      "day": "Giorno",
      "week": "Settimana",
      "month": "Mese"
    },
    "legend": {
      "pending": "In attesa di",
      "holiday": "Vacanza"
    },
    "day_view": {
      "empty": "Nessuna foglia in questo giorno"
    },
    "more": "+{count} altro"
  },
  "team": {
    "page_title": "Team",
    "page_subtitle": "Gestisci i membri del tuo team",
    "tab": {
      "active": "Attivi",
      "inactive": "Inattivi",
      "deleted": "Eliminati"
    },
    "table": {
      "name": "Nome",
      "email": "E-mail",
      "department": "Dipartimento",
      "location": "Sede",
      "role": "Ruolo",
      "status": "Stato",
      "actions": "Azioni",
      "manager": "Responsabile",
      "start_date": "Data di inizio",
      "birthday": "Compleanno",
      "working_days": "Giorni lavorativi",
      "hours_per_week": "Ore settimanali"
    },
    "filter": {
      "search_placeholder": "Cerca membri del team...",
      "department": "Dipartimento",
      "all_departments": "Tutti i dipartimenti",
      "location": "Sede",
      "all_locations": "Tutte le sedi",
      "role": "Ruolo",
      "all_roles": "Tutti i ruoli"
    },
    "role": {
      "owner": "Proprietario",
      "admin": "Amministratore",
      "approver": "Approvatore",
      "employee": "Dipendente"
    },
    "card": {
      "department": "Dipartimento",
      "location": "Sede",
      "manager": "Responsabile",
      "role": "Ruolo",
      "start_date": "Data di inizio",
      "birthday": "Compleanno",
      "working_days": "Giorni lavorativi",
      "hours_per_week": "Ore settimanali",
      "no_department": "Nessun dipartimento",
      "no_location": "Nessuna sede",
      "no_manager": "Nessun responsabile",
      "view_profile": "Visualizza profilo",
      "view_balances": "Visualizza saldi"
    },
    "action": {
      "add_user": "Aggiungi utente",
      "import_from_slack": "Importa da Slack",
      "bulk_import": "Importazione in blocco",
      "invite_member": "Invita membro",
      "edit": "Modifica",
      "deactivate": "Disattiva",
      "activate": "Attiva",
      "delete": "Elimina",
      "restore": "Ripristina",
      "permanent_delete": "Elimina definitivamente",
      "view_leave_history": "Visualizza storico permessi",
      "adjust_balance": "Modifica saldo",
      "send_reminder": "Invia promemoria"
    },
    "empty": {
      "title": "Nessun membro del team trovato",
      "active": "Non ci sono membri attivi nel team.",
      "inactive": "Non ci sono membri inattivi.",
      "deleted": "Non ci sono membri eliminati.",
      "filtered": "Nessun membro corrisponde ai filtri selezionati.",
      "add_first": "Aggiungi il primo membro del team per iniziare."
    },
    "modal": {
      "add_title": "Aggiungi membro del team",
      "edit_title": "Modifica membro del team",
      "import_title": "Importa da Slack",
      "invite_title": "Invita membro",
      "bulk_import_title": "Importazione in blocco",
      "name_label": "Nome completo",
      "email_label": "Indirizzo e-mail",
      "department_label": "Dipartimento",
      "location_label": "Sede",
      "role_label": "Ruolo",
      "manager_label": "Responsabile",
      "start_date_label": "Data di inizio",
      "birthday_label": "Compleanno",
      "working_days_label": "Giorni lavorativi",
      "hours_per_week_label": "Ore settimanali",
      "select_department": "Seleziona dipartimento",
      "select_location": "Seleziona sede",
      "select_role": "Seleziona ruolo",
      "select_manager": "Seleziona responsabile",
      "no_manager": "Nessun responsabile",
      "save_button": "Salva",
      "cancel_button": "Annulla",
      "import_button": "Importa selezionati",
      "invite_button": "Invia invito"
    },
    "toil": {
      "title": "Riposo compensativo (TOIL)",
      "add_button": "Aggiungi TOIL",
      "hours_worked": "Ore lavorate",
      "date": "Data",
      "reason": "Motivo",
      "approved_by": "Approvato da",
      "no_toil": "Nessun TOIL registrato"
    },
    "invite": {
      "email_label": "Indirizzo e-mail",
      "email_placeholder": "nome@azienda.com",
      "message_label": "Messaggio personalizzato (opzionale)",
      "message_placeholder": "Aggiungi un messaggio personale all'invito...",
      "send_button": "Invia invito",
      "success": "Invito inviato con successo",
      "error": "Impossibile inviare l'invito"
    },
    "bulk": {
      "title": "Importazione in blocco",
      "description": "Carica un file CSV per importare più membri del team contemporaneamente.",
      "download_template": "Scarica modello CSV",
      "upload_label": "Carica file CSV",
      "preview_title": "Anteprima importazione",
      "rows_found": "{count} righe trovate",
      "valid_rows": "{count} righe valide",
      "invalid_rows": "{count} righe con errori",
      "import_button": "Importa {count} membri",
      "success": "{count} membri importati con successo",
      "error": "Errore durante l'importazione"
    },
    "instances": {
      "title": "Istanze di congedo",
      "lifetime_used": "Utilizzato (totale)",
      "remaining": "Rimanente",
      "no_instances": "Nessuna istanza di congedo"
    },
    "confirm": {
      "deactivate": "Sei sicuro di voler disattivare questo utente?",
      "deactivate_warning": "L'utente non potrà più accedere al sistema.",
      "activate": "Sei sicuro di voler riattivare questo utente?",
      "delete": "Sei sicuro di voler eliminare questo utente?",
      "delete_warning": "L'utente verrà spostato nella scheda Eliminati.",
      "permanent_delete": "Sei sicuro di voler ELIMINARE DEFINITIVAMENTE {name}?",
      "permanent_delete_warning": "Questa azione non può essere annullata. Tutta la cronologia delle ferie e i saldi verranno eliminati.",
      "permanent_delete_final": "Questa operazione è definitiva! Fai clic su OK per confermare l'eliminazione definitiva.",
      "restore": "Sei sicuro di voler ripristinare questo utente?",
      "restore_info": "L'utente verrà riattivato e potrà accedere nuovamente."
    },
    "error": {
      "load": "Impossibile caricare i membri del team",
      "add": "Impossibile aggiungere l'utente",
      "edit": "Impossibile modificare l'utente",
      "deactivate": "Impossibile disattivare l'utente",
      "activate": "Impossibile attivare l'utente",
      "delete": "Impossibile eliminare l'utente",
      "restore": "Impossibile ripristinare l'utente",
      "permanent_delete": "Impossibile eliminare definitivamente l'utente",
      "import": "Impossibile importare gli utenti",
      "invite": "Impossibile inviare l'invito"
    }
  },
  "settings": {
    "page_title": "Impostazioni",
    "page_subtitle": "Configura le impostazioni e i criteri del tuo spazio di lavoro",
    "access_denied": {
      "title": "Accesso amministratore richiesto",
      "message": "Per accedere alle impostazioni sono necessarie le autorizzazioni di amministratore."
    },
    "tab": {
      "workspace": "Area di lavoro",
      "departments": "Dipartimenti",
      "locations": "Posizioni",
      "holidays": "Vacanze",
      "compliance": "Conformità",
      "balances": "Saldi iniziali",
      "notifications": "Notifiche",
      "integrations": "Integrazioni",
      "import": "Importare",
      "data_management": "Gestione dei dati",
      "locked_tooltip": "Esegui l'upgrade per sbloccare questa funzionalità"
    },
    "workspace": {
      "title": "Impostazioni dell'area di lavoro",
      "name_label": "Nome dell'area di lavoro",
      "visibility_label": "Lascia visibilità",
      "visibility": {
        "all": "Tutti possono vedere tutti andarsene",
        "department": "Vedi solo il tuo dipartimento",
        "approvers": "Solo gli approvatori possono vedere tutto"
      },
      "save_button": "Salva modifiche"
    },
    "departments": {
      "title": "Dipartimenti",
      "subtitle": "Organizza il tuo team in dipartimenti con policy personalizzate",
      "add_button": "Aggiungi reparto",
      "name_label": "Nome del dipartimento",
      "working_days_label": "Giorni lavorativi",
      "hours_per_day_label": "Ore al giorno",
      "approvers_label": "Approvatori",
      "notification_channel_label": "Canale di notifica",
      "policies_button": "Gestisci le policy",
      "edit_button": "Modificare",
      "delete_button": "Eliminare",
      "confirm_delete": "Sei sicuro di voler eliminare questo reparto?",
      "no_departments": "Nessun dipartimento ancora creato"
    },
    "locations": {
      "title": "Posizioni",
      "subtitle": "Gestire le sedi degli uffici e i loro calendari delle festività",
      "add_button": "Aggiungi posizione",
      "name_label": "Nome della posizione",
      "country_label": "Paese",
      "timezone_label": "Fuso orario",
      "edit_button": "Modificare",
      "delete_button": "Eliminare",
      "no_locations": "Nessuna posizione creata ancora"
    },
    "holidays": {
      "title": "Giorni festivi",
      "subtitle": "Gestire i giorni festivi per ogni sede",
      "add_button": "Aggiungi festività",
      "location_label": "Posizione",
      "all_locations": "Tutte le località",
      "year_label": "Anno",
      "name_label": "Nome della festa",
      "date_label": "Data",
      "half_day_label": "Mezza giornata",
      "edit_button": "Modificare",
      "delete_button": "Eliminare",
      "no_holidays": "Nessuna festività per questa località e per questo anno",
      "import_button": "Festività di importazione"
    },
    "leave_types": {
      "title": "Tipi di congedo",
      "subtitle": "Configurare i tipi di congedo e i diritti",
      "add_button": "Aggiungi tipo di congedo",
      "name_label": "Nome",
      "color_label": "Colore",
      "unit_label": "Unità",
      "unit": {
        "days": "Giorni",
        "hours": "Ore"
      },
      "entitlement_label": "Diritto predefinito",
      "unlimited": "Illimitato",
      "requires_approval_label": "Richiede approvazione",
      "allow_half_day_label": "Concedi mezza giornata",
      "is_paid_label": "congedo retribuito",
      "carryover_label": "Riporto massimo",
      "priority_label": "Priorità",
      "edit_button": "Modificare",
      "delete_button": "Eliminare",
      "no_leave_types": "Nessun tipo di congedo configurato"
    },
    "notifications": {
      "title": "Notifiche",
      "subtitle": "Configura come e quando vengono inviate le notifiche",
      "slack_channel_label": "Canale Slack",
      "email_notifications_label": "Notifiche e-mail",
      "daily_digest_label": "Riepilogo giornaliero",
      "weekly_summary_label": "Riepilogo settimanale",
      "save_button": "Salva impostazioni"
    },
    "integrations": {
      "title": "Integrazioni",
      "subtitle": "Collega i tuoi strumenti e calendari HR",
      "connect_button": "Collegare",
      "disconnect_button": "Disconnettersi",
      "sync_button": "Sincronizza ora",
      "view_logs_button": "Visualizza i registri",
      "last_sync": "Ultima sincronizzazione: {data}",
      "never_synced": "Mai sincronizzato",
      "status": {
        "connected": "Collegato",
        "disconnected": "Non connesso",
        "error": "Errore"
      }
    },
    "data": {
      "title": "Gestione dei dati",
      "subtitle": "Esegui il backup dei dati o cancella le informazioni dell'area di lavoro",
      "current_data": "Dati attuali",
      "total_users": "Utenti totali",
      "admins": "Amministratori",
      "regular_users": "Utenti regolari",
      "leave_requests": "Richieste di congedo",
      "backup": {
        "title": "Scarica Backup",
        "description": "Scarica un backup completo dei dati del tuo spazio di lavoro come file JSON.",
        "button": "Scarica Backup"
      },
      "google_drive": {
        "title": "Backup di Google Drive",
        "description": "Backup giornalieri automatici su Google Drive.",
        "connect_button": "Connetti Google Drive",
        "folder_label": "Cartella di backup",
        "auto_backup_label": "Abilita il backup giornaliero automatico",
        "backup_now_button": "Esegui il backup ora",
        "last_backup": "Ultimo backup: {data}",
        "upgrade_message": "Il piano Business offre backup giornalieri automatici su Google Drive."
      },
      "clear_users": {
        "title": "Cancella utenti non amministratori",
        "description": "Rimuovi tutti gli utenti tranne amministratori e proprietari. Verranno eliminati {count} utenti, i loro permessi e tutte le richieste di ferie in sospeso.",
        "warning": "Attenzione: questa azione non può essere annullata. Assicurati di scaricare prima un backup.",
        "confirm_prompt": "Digitare ELIMINA per confermare",
        "confirm_description": "Questa operazione rimuoverà definitivamente {count} utenti e tutti i loro dati.",
        "button": "Cancella utenti non amministratori",
        "confirm_button": "Conferma eliminazione utenti"
      },
      "clear_history": {
        "title": "Cancella cronologia delle assenze",
        "description": "Rimuovi tutte le richieste di ferie e azzera tutti i saldi delle ferie. Questo eliminerà {count} richieste di ferie.",
        "warning": "Attenzione: questa azione non può essere annullata. Tutta la cronologia delle ferie verrà eliminata definitivamente e i saldi verranno azzerati.",
        "confirm_description": "Ciò eliminerà definitivamente {count} richieste di ferie e reimposterà tutti i saldi.",
        "button": "Cancella cronologia delle assenze",
        "confirm_button": "Conferma Cancella cronologia"
      },
      "restore": {
        "title": "Ripristina dal backup",
        "description": "Carica un file JSON di backup per ripristinare i dati del tuo spazio di lavoro. Questo sostituirà tutti i dati esistenti.",
        "warning": "Attenzione: il ripristino sostituirà tutti gli utenti, i tipi di congedo, le richieste di congedo, i reparti e i saldi correnti. Solo il proprietario dell'area di lavoro può eseguire questa azione.",
        "select_file": "Seleziona file di backup",
        "backup_details": "Dettagli del backup",
        "file": "File",
        "version": "Versione",
        "created": "Creato",
        "confirm_prompt": "Digitare RESTORE per confermare",
        "confirm_description": "Questo sostituirà in modo permanente tutti i dati esistenti con il backup.",
        "button": "Conferma ripristino",
        "restoring": "Ripristino in corso...",
        "success": "Ripristino completato con successo!"
      }
    }
  },
  "audit": {
    "page_title": "Pista di controllo",
    "page_subtitle": "Visualizza tutte le modifiche apportate nella tua area di lavoro",
    "super_admin_label": "(Super amministratore)",
    "entries_count": "voci totali",
    "filter": {
      "action_label": "Tipo di azione",
      "all_actions": "Tutte le azioni",
      "entity_label": "Tipo di entità",
      "all_entities": "Tutte le entità",
      "user_label": "Modificato da",
      "all_users": "Tutti gli utenti"
    },
    "action": {
      "user_updated": "Utente aggiornato",
      "user_deleted": "Utente eliminato",
      "user_imported": "Utente importato",
      "leave_requested": "Congedo richiesto",
      "leave_approved": "Lascia approvato",
      "leave_rejected": "Lasciare rifiutato",
      "leave_cancelled": "Lascia annullato",
      "leave_type_created": "Tipo di congedo creato",
      "leave_type_updated": "Tipo di congedo aggiornato",
      "leave_type_deleted": "Tipo di congedo eliminato",
      "balance_adjusted": "Saldo rettificato",
      "department_created": "Dipartimento creato",
      "department_updated": "Dipartimento aggiornato",
      "department_deleted": "Dipartimento cancellato",
      "audit_log_deleted": "Registro di controllo eliminato"
    },
    "table": {
      "date": "Data",
      "user": "Utente",
      "action": "Azione",
      "entity": "Entità",
      "details": "Dettagli"
    },
    "no_entries": "Nessuna voce del registro di controllo trovata"
  },
  "billing": {
    "page_title": "Fatturazione e abbonamento",
    "page_subtitle": "Gestisci i dettagli del tuo abbonamento e della fatturazione",
    "access_denied": {
      "title": "Accesso negato",
      "message": "Solo il proprietario dell'area di lavoro può visualizzare e gestire la fatturazione.",
      "button": "Torna alla dashboard"
    },
    "current_plan": {
      "title": "Piano attuale"
    },
    "status": {
      "none": "Nessun abbonamento"
    },
    "discount_badge": "Sconto applicato del {percent}%",
    "trial_info": {
      "title": "La prova termina il {data}",
      "days_remaining": "{giorni} giorni rimanenti"
    },
    "renewal_info": {
      "title": "Prossima data di fatturazione"
    },
    "action": {
      "upgrade": "Passa a Pro",
      "view_plans": "Visualizza tutti i piani",
      "manage": "Gestisci abbonamento"
    },
    "plan": {
      "trial": "Prova gratuita",
      "free": "Gratuito",
      "pro": "Professionista",
      "business": "Attività commerciale"
    },
    "feature": {
      "up_to_5_users": "Fino a 5 utenti",
      "up_to_50_users": "Fino a 50 utenti",
      "unlimited_users": "Utenti illimitati",
      "basic": "Caratteristiche di base",
      "trial_14days": "Prova di 14 giorni",
      "unlimited_requests": "Richieste di ferie illimitate",
      "slack_integration": "Integrazione Slack",
      "planner": "Vista pianificatore",
      "custom_leave_types": "Tipi di congedo personalizzati",
      "approval_workflows": "Flussi di lavoro di approvazione",
      "priority_support": "Supporto prioritario",
      "multi_team": "Supporto multi-team",
      "analytics": "Analisi avanzate",
      "api_access": "Accesso API",
      "dedicated_support": "Supporto dedicato"
    }
  },
  "upgrade": {
    "page_title": "Scegli il tuo piano",
    "page_subtitle": "Prezzi semplici e trasparenti. Nessun costo per utente.",
    "plan_badge": "I più popolari",
    "period": {
      "month": "/mese",
      "year": "/anno"
    },
    "yearly_savings": "o EUR {annuale}/anno (risparmia {percent}%)",
    "loading": "Caricamento dei piani in corso...",
    "guarantee": {
      "title": "Garanzia di rimborso entro 30 giorni",
      "description": "Non sei soddisfatto? Ricevi un rimborso completo, senza domande."
    },
    "faq": {
      "title": "Domande frequenti",
      "q1": "Posso cambiare programma in seguito?",
      "a1": "Sì, puoi effettuare l'upgrade o il downgrade in qualsiasi momento. Le modifiche hanno effetto immediato e sono proporzionali.",
      "q2": "Quali metodi di pagamento accettate?",
      "a2": "Accettiamo tutte le principali carte di credito (Visa, Mastercard, American Express) tramite il nostro fornitore di pagamenti sicuri Stripe.",
      "q3": "C'è un contratto o un impegno?",
      "a3": "No, tutti i piani sono mensili. Puoi disdire in qualsiasi momento senza penali.",
      "q4": "Cosa succede quando raggiungo il limite di utenti?",
      "a4": "Ti verrà chiesto di passare a un piano superiore. Gli utenti esistenti continueranno ad avere accesso."
    },
    "contact_note": "Hai domande? Contattaci a",
    "current_plan_badge": "Piano attuale",
    "button": {
      "upgrade": "Passa a {piano}",
      "start_trial": "Inizia la prova gratuita"
    }
  },
  "login": {
    "processing_title": "Accesso in corso...",
    "processing_message": "Attendi mentre verifichiamo le tue credenziali da Slack.",
    "subtitle": "Gestisci con facilità le richieste di ferie del tuo team",
    "slack_button": "Aggiungi a Slack",
    "existing_user_text": "Utilizzi già Unplug?",
    "existing_user_info": "Apri l'app in Slack e clicca su Dashboard di amministrazione per accedere.",
    "terms_text": "Continuando",
    "error": {
      "workspace_not_found": "Area di lavoro non trovata. Controlla l'URL.",
      "invalid_response": "Risposta non valida dal server",
      "generic": "Accesso non riuscito",
      "please_retry": "Accesso non riuscito. Riprova."
    }
  },
  "help": {
    "page_title": "Centro assistenza",
    "page_subtitle": "Trova le risposte e impara come usare Unplug",
    "action": {
      "restart_tour": "Riavvia il tour"
    },
    "search": {
      "placeholder": "Cerca articoli di aiuto, FAQ...",
      "results": "Trovati {articles} articoli e {faqs} FAQ corrispondenti a {query}"
    },
    "quick_link": {
      "getting_started": "Iniziare",
      "faqs": "Domande frequenti",
      "contact_support": "Contatta l'assistenza",
      "tour": "Fai il tour"
    }
  },
  "profile": {
    "page_title": "Impostazioni del profilo",
    "personal_info": "Informazioni personali",
    "name_label": "Nome e cognome",
    "email_label": "E-mail",
    "department_label": "Dipartimento",
    "location_label": "Posizione",
    "manager_label": "Manager",
    "start_date_label": "Data di inizio",
    "save_button": "Salva modifiche",
    "preferences": "Preferenze",
    "language_label": "Lingua",
    "timezone_label": "Fuso orario"
  },
  "planner": {
    "page_title": "Pianificatore",
    "page_subtitle": "Calendario visivo del team che mostra tutte le assenze",
    "feature_name": "Pianificatore",
    "feature_description": "Calendario visivo del team che mostra tutte le assenze a colpo d'occhio",
    "empty_state": "Nessun membro del team trovato",
    "filter": {
      "pending_request": "Richiesta in sospeso",
      "filter_by": "Filtra per",
      "department": "Dipartimento",
      "all_departments": "Tutti i dipartimenti",
      "location": "Sede",
      "all_locations": "Tutte le sedi"
    },
    "export": {
      "button": "Esporta",
      "title": "Esporta dati ferie",
      "format": "Formato esportazione",
      "buddy_payroll": "Buddy Payroll",
      "generic_csv": "CSV generico",
      "date_range": "Intervallo date",
      "departments": "Dipartimenti"
    },
    "legend": {
      "approved": "Approvato",
      "pending": "In sospeso",
      "holiday": "Festività",
      "holidays": "Festività",
      "weekend": "Fine settimana",
      "non_working": "Giorno non lavorativo",
      "partial_day": "Assenze inferiori a un giorno"
    },
    "no_data": "Nessuna assenza da visualizzare"
  },
  "error": {
    "network": "Errore di rete. Controlla la connessione.",
    "unauthorized": "Non sei autorizzato a eseguire questa azione.",
    "not_found": "La risorsa richiesta non è stata trovata.",
    "server": "Errore del server. Riprova più tardi.",
    "validation": "Si prega di controllare il modulo per eventuali errori.",
    "generic": "Si è verificato un errore. Riprova.",
    "session_expired": "La tua sessione è scaduta. Effettua nuovamente l'accesso."
  },
  "success": {
    "saved": "Modifiche salvate con successo.",
    "deleted": "Eliminato con successo.",
    "created": "Creato con successo.",
    "updated": "Aggiornato con successo.",
    "submitted": "Inviato con successo.",
    "sent": "Inviato con successo."
  },
  "weekday": {
    "monday": "Lunedi",
    "tuesday": "Martedì",
    "wednesday": "Mercoledì",
    "thursday": "Giovedì",
    "friday": "Venerdì",
    "saturday": "Sabato",
    "sunday": "Domenica",
    "mon": "lun",
    "tue": "Martedì",
    "wed": "Mercoledì",
    "thu": "Giovedì",
    "fri": "Ven",
    "sat": "Sab",
    "sun": "Sole"
  },
  "month": {
    "january": "Gennaio",
    "february": "Febbraio",
    "march": "Marzo",
    "april": "aprile",
    "may": "Maggio",
    "june": "Giugno",
    "july": "Luglio",
    "august": "agosto",
    "september": "settembre",
    "october": "ottobre",
    "november": "novembre",
    "december": "Dicembre",
    "jan": "gennaio",
    "feb": "Febbraio",
    "mar": "Marzo",
    "apr": "aprile",
    "may_short": "Maggio",
    "jun": "giugno",
    "jul": "luglio",
    "aug": "agosto",
    "sep": "Settembre",
    "oct": "ottobre",
    "nov": "novembre",
    "dec": "Dicembre"
  },
  "language": {
    "en": "Inglese",
    "es": "spagnolo",
    "fr": "francese",
    "de": "tedesco",
    "it": "Italiano",
    "pt": "portoghese",
    "pl": "Polacco",
    "nl": "Olandese",
    "sv": "svedese",
    "no": "norvegese"
  },
  "leave_type_name": {
    "Vacation": "Ferie",
    "Vacation Leave": "Ferie",
    "Annual Leave": "Ferie annuali",
    "Unpaid Vacation": "Ferie non retribuite",
    "Unpaid Leave": "Congedo non retribuito",
    "Sick Leave": "Malattia",
    "Sick Leave (Full Pay)": "Malattia (retribuzione completa)",
    "Maternity Leave": "Congedo di maternità",
    "Paternity Leave": "Congedo di paternità",
    "Parental Leave": "Congedo parentale",
    "Bereavement Leave": "Congedo per lutto",
    "Marriage Leave": "Congedo matrimoniale",
    "Jury Leave": "Congedo per giuria",
    "Jury Duty": "Servizio di giuria",
    "Work Travel": "Viaggio di lavoro",
    "Working Remotely": "Lavoro da remoto",
    "Remote Work": "Lavoro da remoto",
    "Work From Home": "Lavoro da casa",
    "Personal Day": "Giorno personale",
    "TOIL": "Riposo compensativo",
    "Time Off In Lieu": "Riposo compensativo",
    "Compassionate Leave": "Congedo per motivi personali",
    "Study Leave": "Congedo studio",
    "Training": "Formazione",
    "Public Holiday": "Festività"
  }
}